import { defineMessages } from 'react-intl';

export default defineMessages({
    returningToWawanesa: {
        id: 'quoteandbind.common.controllers.PaymentCallbackCtrl.Returning to Wawanesa.com...',
        defaultMessage: 'Returning to Wawanesa.com...',
    }
});